module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 5.5e8109c5.png";